import { createSelector } from '@ngrx/store';
import { IVisorState } from 'app/visor/shared/models/mapModels';
import { getVisorState } from './config-leaflet.selector';

export const getInfoLayerState = createSelector(getVisorState, (state: IVisorState) => state.infoLayers.infoLayers);
export const getInfoDataState = createSelector(getVisorState, (state: IVisorState) => state.infoLayers.loaded);
export const getErrorLoadingInfoLayerState = createSelector(getVisorState, (state: IVisorState) => state.infoLayers.error);
